import type { DisconnectReason } from "./DisconnectMarketplaceDialog";

/** Step 1 consequence line — includes agent name (scenario 1136). */
export function DISCONNECT_STEP1_CONSEQUENCE(agentName: string): string {
  return `Ends your connection with ${agentName}. Your passport can go back on the market.`;
}

/**
 * Human-readable labels for each reason value.
 * Scenario 1137 pins these display labels; the machine values are the wire values.
 */
export const DISCONNECT_REASON_LABELS: Record<DisconnectReason, string> = {
  chose_someone_else: "I chose someone else",
  not_ready_to_buy: "I'm not ready to buy",
  agent_unresponsive: "Agent wasn't responsive",
  not_a_good_fit: "Not a good fit",
  incentive_not_honored: "Agreed incentive wasn't honored",
  other: "Other",
};
